import React from "react";
import PropTypes from "prop-types";
import TextareaAutosize from "react-textarea-autosize";
import { Delete, Input, Field, Control, Label, Column, Help } from "rbx";
import {
  ItemSelect,
  BooleanInput,
  ItemCategorySelect,
  InventoryStorageDimSelect
} from "../inputs";
import "./styles.scss";

import { useAuthorization } from "../Authorization";

function WorkOrderPartItem({
  item,
  disabled = false,
  removeRow,
  handleChange,
  WorkOrder,
  companySettings,
  PrimaryStorageDimension,
  SecondaryStorageDimension,
  TertiaryStorageDimension,
  UsePrimaryStorageDimension,
  UseSecondaryStorageDimension,
  UseTertiaryStorageDimension,
  CompanyLocRecIdRef
}) {
  const defaultDisabled = true;
  const AdminAuth = useAuthorization(["ADMIN"]);
  const FleetAuth = useAuthorization(["FLEET"]);
  const MechAuth = useAuthorization(["MECH"]);
  const isMechanic = MechAuth && !AdminAuth && !FleetAuth;

  return (
    <React.Fragment>
      <Column.Group style={{ borderBottom: "solid 0.5px lightgray" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            marginTop: "2.5rem"
          }}
        >
          <Delete
            disabled={disabled}
            style={{ opacity: disabled ? 0 : 1 }}
            onClick={removeRow}
          />
        </div>
        <Column>
          <Field class="without-arrows">
            <Column.Group>
              <Column size={5}>
                <Field kind="group">
                  <Control style={{ width: "33%" }}>
                    <Label>Item Category</Label>
                    <ItemCategorySelect
                      icon="globe"
                      name={`ItemCategoryRecIdRef_${item.RecId}`}
                      value={item.ItemCategoryRecIdRef}
                      onChange={handleChange}
                    />
                  </Control>
                  {WorkOrder.Billable &&
                    WorkOrder.Billable === "Y" &&
                    companySettings.AllowMaintenanceBilling && (
                      <Control>
                        <Label>Billable</Label>
                        <BooleanInput
                          name={`BillFlag_${item.RecId}`}
                          readOnly={disabled}
                          value={item.BillFlag}
                          onChange={handleChange}
                        />
                      </Control>
                    )}
                  <Control expanded>
                    <ItemSelect
                      autoFocus
                      orderByNumber
                      required
                      showHelp
                      ItemCategoryRecIdRef={parseInt(item.ItemCategoryRecIdRef)}
                      disabled={disabled}
                      kind="WOParts"
                      label="Item Number"
                      name={`ItemRecIdRef_${item.RecId}`}
                      value={item.ItemRecIdRef}
                      onChange={handleChange}
                    />
                  </Control>
                  <Control expanded>
                    <ItemSelect
                      required
                      showHelp
                      ItemCategoryRecIdRef={parseInt(item.ItemCategoryRecIdRef)}
                      disabled={disabled}
                      kind="WOParts"
                      label="Item Description"
                      name={`ItemDescriptionRecIdRef_${item.RecId}`}
                      value={item.ItemDescriptionRecIdRef}
                      onChange={handleChange}
                    />
                  </Control>
                </Field>
              </Column>
              {PrimaryStorageDimension && UsePrimaryStorageDimension && (
                <Column size={1}>
                  <InventoryStorageDimSelect
                    CompanyLocRecIdRef={CompanyLocRecIdRef}
                    Filters={{
                      InvDim1RecIdRef_in: item.InvDim1Availables
                    }}
                    InvStorageDimRecIdRef={PrimaryStorageDimension.RecId}
                    ItemRecIdRef={item.ItemRecIdRef && item.ItemRecIdRef.value}
                    disabled={disabled || !item.ItemRecIdRef}
                    icon="globe"
                    label={PrimaryStorageDimension?.CodeDescription}
                    name={`InvDim1RecIdRef_${item.RecId}`}
                    value={item.InvDim1RecIdRef}
                    variables={{ Active: true }}
                    onChange={handleChange}
                  />
                </Column>
              )}
              {SecondaryStorageDimension && UseSecondaryStorageDimension && (
                <Column size={1}>
                  <InventoryStorageDimSelect
                    CompanyLocRecIdRef={CompanyLocRecIdRef}
                    Filters={{
                      InvDim2RecIdRef_in: item.InvDim2Availables
                    }}
                    InvStorageDimRecIdRef={SecondaryStorageDimension.RecId}
                    ItemRecIdRef={item.ItemRecIdRef && item.ItemRecIdRef.value}
                    disabled={disabled || !item.ItemRecIdRef}
                    icon="globe"
                    label={SecondaryStorageDimension?.CodeDescription}
                    name={`InvDim2RecIdRef_${item.RecId}`}
                    value={item.InvDim2RecIdRef}
                    variables={{ Active: true }}
                    onChange={handleChange}
                  />
                </Column>
              )}
              {TertiaryStorageDimension && UseTertiaryStorageDimension && (
                <Column size={1}>
                  <InventoryStorageDimSelect
                    CompanyLocRecIdRef={CompanyLocRecIdRef}
                    Filters={{
                      InvDim3RecIdRef_in: item.InvDim3Availables
                    }}
                    InvStorageDimRecIdRef={TertiaryStorageDimension.RecId}
                    ItemRecIdRef={item.ItemRecIdRef && item.ItemRecIdRef.value}
                    disabled={disabled || !item.ItemRecIdRef}
                    icon="globe"
                    label={TertiaryStorageDimension?.CodeDescription}
                    name={`InvDim3RecIdRef_${item.RecId}`}
                    value={item.InvDim3RecIdRef}
                    variables={{ Active: true }}
                    onChange={handleChange}
                  />
                </Column>
              )}
              <Column size={3}>
                <Field kind="group">
                  <Control expanded>
                    <Label>Tot OH</Label>
                    <Input
                      disabled={defaultDisabled}
                      style={{ textAlign: "right" }}
                      value={item.QtyOnHand}
                    />
                  </Control>
                  <Control expanded>
                    <Label>Dim OH</Label>
                    <Input
                      disabled={defaultDisabled}
                      style={{ textAlign: "right" }}
                      value={item.DimOH}
                    />
                  </Control>
                  <Control expanded>
                    <Label>Quantity</Label>
                    <Input
                      required
                      color={item.DimOH < item.Quantity ? "warning" : ""}
                      disabled={disabled || !item.ItemRecIdRef}
                      name={`Quantity_${item.RecId}`}
                      style={{ textAlign: "right" }}
                      type="number"
                      value={item.Quantity}
                      onChange={handleChange}
                    />
                    {item.DimOH < item.Quantity && (
                      <Help color="danger" style={{ textAlign: "right" }}>
                        Quantity Unavailable
                      </Help>
                    )}
                  </Control>
                  {!isMechanic && (
                    <Control expanded>
                      <Label>Cost</Label>
                      <Input disabled type="text" value={item.Cost} />
                    </Control>
                  )}
                </Field>
              </Column>
              <Column>
                <Field>
                  <Control expanded>
                    <Label>Note</Label>
                    <TextareaAutosize
                      className="auto-height-textarea input"
                      disabled={disabled}
                      minRows={1}
                      name={`LineNote_${item.RecId}`}
                      type="text"
                      value={item.LineNote}
                      onChange={handleChange}
                    />
                  </Control>
                </Field>
              </Column>
            </Column.Group>
          </Field>
        </Column>
      </Column.Group>
    </React.Fragment>
  );
}

WorkOrderPartItem.propTypes = {
  item: PropTypes.object,
  disabled: PropTypes.bool,
  removeRow: PropTypes.func,
  handleChange: PropTypes.func,
  WorkOrder: PropTypes.object,
  companySettings: PropTypes.object,
  PrimaryStorageDimension: PropTypes.object,
  SecondaryStorageDimension: PropTypes.object,
  TertiaryStorageDimension: PropTypes.object,
  UsePrimaryStorageDimension: PropTypes.bool,
  UseSecondaryStorageDimension: PropTypes.bool,
  UseTertiaryStorageDimension: PropTypes.bool,
  CompanyLocRecIdRef: PropTypes.number
};
export default WorkOrderPartItem;
